<script>
  import { onMount } from "svelte";
  import Footer from "./components/Footer.svelte";
  import Header from "./components/Header.svelte";
  import Model from "./components/custom/Model.svelte";
  import LoadingScreen from "./components/custom/LoadingScreen.svelte";
  import VideoPlayer from "./components/VideoPlayer.svelte";
  import BlurryScreen from "./components/custom/BlurryScreen.svelte";
  import Legal from "./components/Legal.svelte";

  export let content;
  export let video;

  let featureId = -1;
  let modelViewer = "";
  let isModelVisible = false;
  let openVideo = false;
  let openLegal = false;
  let showBlurryScreen = false;

  onMount(function () {
    modelViewer = document.getElementById("unit01");
  });

  function isVisible(event) {
    isModelVisible = event.detail;
    fadeInAnimation();
  }

  function closeVideoHandler(event) {
    showBlurryScreen = event.detail;
    openVideo = event.detail;
  }

  function openVideoHandler(event) {
    showBlurryScreen = event.detail.active;
    openVideo = event.detail.active;
    featureId = event.detail.actualId;
  }

  function openModalHandler(event) {
    showBlurryScreen = event.detail;
    openLegal = event.detail;
  }

  function closeModalHandler(event) {
    showBlurryScreen = event.detail;
    openLegal = event.detail;
  }

  function fadeInAnimation() {
    let fadeInModel = new TimelineMax();
    fadeInModel.set(".ModeViewerHolder", { opacity: 0, visibility: "visible" });
    fadeInModel.set(modelViewer, { opacity: 0 });

    fadeInModel.add("modelIntroAnim");
    fadeInModel.set(modelViewer, { y: "30%" });
    fadeInModel.to(
      ".ModeViewerHolder",
      3,
      { opacity: 1, ease: "power4.out" },
      "modelIntroAnim"
    );
    fadeInModel.to(
      modelViewer,
      2.5,
      { opacity: 1, ease: "Expo.easeOut" },
      "modelIntroAnim"
    );
    fadeInModel.to(
      modelViewer,
      2,
      { y: "0%", ease: "Expo.easeOut" },
      "modelIntroAnim"
    );
  }
</script>

<style>
  .main-container {
    text-align: center;
    margin: 0 auto;
    background-size: cover;
    width: 100%;
    height: 100%;
    background-color: #000000;
  }
</style>

<svelte:head>
  <script
    src="https://unpkg.com/@webcomponents/webcomponentsjs@2.1.3/webcomponents-loader.js">
  </script>
  <script
    src="https://unpkg.com/intersection-observer@0.5.1/intersection-observer.js">
  </script>
  <script
    src="https://unpkg.com/resize-observer-polyfill@1.5.1/dist/ResizeObserver.js">
  </script>
  <script src="https://unpkg.com/focus-visible@5.1.0/dist/focus-visible.js">
  </script>
</svelte:head>
<svelte:options accessors={true} />
<div class="main-container">
  {#if !isModelVisible}
    <LoadingScreen loader={content.assets.loader} />
  {/if}
  {#if showBlurryScreen}
    <BlurryScreen />
  {/if}
  {#if openLegal}
    <Legal
      copy={content.footer.legal.description}
      exitButton={content.assets.exit_button}
      on:close-modal={closeModalHandler} />
  {/if}
  <Header
    headline={content.header.headline}
    subheadline={content.header.subheadline_desktop}
    arrow={content.assets.down_arrow} />
  <Model
    {modelViewer}
    model={content.assets.model}
    lights={content.assets.lights}
    background={content.assets.background}
    checkmark={content.assets.checkmark}
    hotspot={content.hotspots}
    blueCheckmark={content.assets.blue_checkmark}
    backCopy={content.back_copy}
    backArrow={content.assets.back_arrow}
    on:isVisible={isVisible}
    on:open-video={openVideoHandler}
    zoomifyGlass={content.assets.zoomify_glass}
    landscapeImg={content.assets.zoomify_glassFront}
    zoomifyGlassShadow={content.assets.zoomify_glassBack} />
  {#if openVideo}
    <BlurryScreen />
    <VideoPlayer
      videoId={video[featureId].video_id}
      exitButton={content.assets.exit_button}
      on:close-video={closeVideoHandler} />
  {/if}
  <Footer
    copy={content.footer}
    on:open-modal={openModalHandler}
    logo={content.assets.evo_checkmark} />
</div>
